/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SharedClient } from './SharedClient';
import {
    SharedClientFromJSON,
    SharedClientFromJSONTyped,
    SharedClientToJSON,
    SharedClientToJSONTyped,
} from './SharedClient';

/**
 * 
 * @export
 * @interface GetProfileV2Response
 */
export interface GetProfileV2Response {
    /**
     * 
     * @type {SharedClient}
     * @memberof GetProfileV2Response
     */
    client: SharedClient;
    /**
     * 
     * @type {string}
     * @memberof GetProfileV2Response
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProfileV2Response
     */
    mobile?: string | null;
}

/**
 * Check if a given object implements the GetProfileV2Response interface.
 */
export function instanceOfGetProfileV2Response(value: object): value is GetProfileV2Response {
    if (!('client' in value) || value['client'] === undefined) return false;
    return true;
}

export function GetProfileV2ResponseFromJSON(json: any): GetProfileV2Response {
    return GetProfileV2ResponseFromJSONTyped(json, false);
}

export function GetProfileV2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProfileV2Response {
    if (json == null) {
        return json;
    }
    return {
        
        'client': SharedClientFromJSON(json['client']),
        'email': json['email'] == null ? undefined : json['email'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
    };
}

export function GetProfileV2ResponseToJSON(json: any): GetProfileV2Response {
    return GetProfileV2ResponseToJSONTyped(json, false);
}

export function GetProfileV2ResponseToJSONTyped(value?: GetProfileV2Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client': SharedClientToJSON(value['client']),
        'email': value['email'],
        'mobile': value['mobile'],
    };
}

